// --- DetalleEntregasModal.jsx ---
import React, { useState, useEffect } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { getRegistroRecepciones } from "../../services/RegistroRecepciones"; // ✅ Importar correctamente
import { fetchUser } from '../../utils/fetchUser';

export default function DetalleRecepcionModal({ onClose, desde, hasta }) {
  const [entregas, setEntregas] = useState([]);
  const userInfo = fetchUser();

  useEffect(() => {
    async function fetch() {
      const data = await getRegistroRecepciones(desde, hasta, userInfo.usuario);
      setEntregas(data || []);
    }
    fetch();
  }, [desde, hasta]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 w-full max-w-2xl rounded-2xl shadow-lg overflow-y-auto max-h-[90vh]">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-semibold">Detalle Bolsas Recolectadas</h3>
          <MdOutlineCancel className="cursor-pointer" onClick={onClose} />
        </div>
        <div className="p-4 overflow-x-auto">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2">Fecha</th>
                <th className="px-4 py-2">Cantidad (bolsas)</th>
              </tr>
            </thead>
            <tbody>
              {entregas.length === 0 ? (
                <tr>
                  <td colSpan="2" className="py-6 text-center">No hay entregas.</td>
                </tr>
              ) : (
                entregas.map((e, i) => (
                  <tr key={i} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-2">
                      {new Date(e.fechaCreacion).toLocaleDateString()}
                    </td>
                    <td className="px-4 py-2 font-medium">{e.cantidad}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
